import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getCurrentMembership } from 'services/memberships';
import { getUserProfile } from 'services/user';
import { Sort } from 'styled_components/Common/Sort';
import { SortProvider } from 'context/SortContext';

const HomeAccountSwitchStyle = styled.div`
	position: absolute;
	right: ${({ sortWidth }) => `calc(4vw + ${sortWidth}px)`};
	z-index: 200;
	margin-top: 6vh;
	font-family: 'Bourgeois-BoldCondensed';
	font-size: 1.2rem;
	text-transform: uppercase;
	color: ${props => props.theme.defaultFontColor};
	#sort {
		width: auto;
		min-width: 150px;
		.filter-reveal {
			width: ${({ sortWidth }) => `${sortWidth}px`};
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;
function getMemberships() {
	const userProfile = getUserProfile();
	const memberships = userProfile?.memberships;
	const SORT_SELECTIONS = [];

	memberships &&
		memberships.forEach(membership => {
			SORT_SELECTIONS.push({
				displayValue: membership?.organizationName,
				value: membership?.organizationId,
			});
		});

	return SORT_SELECTIONS;
}

export const HomeAccountSwitch = ({ accountSwitch }) => {
	const currentMembership = getCurrentMembership();
	const SORT_OPTIONS = getMemberships();

	const [sortWidth, setSortWidth] = useState(0);

	useEffect(() => {
		const updateSortWidth = () => {
			const sortElement = document.getElementById('sort');
			if (sortElement) {
				setSortWidth(sortElement.offsetWidth);
			}
		};

		setTimeout(updateSortWidth, 500); // Initial call to set the width

		window.addEventListener('resize', updateSortWidth); // Add event listener for resize

		return () => {
			window.removeEventListener('resize', updateSortWidth); // Cleanup event listener on unmount
		};
	}, []);

	function updateSortSelected(selected) {
		const id = selected?.value;
		accountSwitch(id);
		updateSortWidth();
	}

	return (
		<HomeAccountSwitchStyle className='home-account-switch' sortWidth={sortWidth}>
			<SortProvider>
				<Sort
					module='support'
					selected={{
						displayValue: currentMembership?.organizationName,
						value: currentMembership?.organizationId,
					}}
					options={SORT_OPTIONS}
					callback={updateSortSelected}
					filterHeading='Company'
				/>
			</SortProvider>
		</HomeAccountSwitchStyle>
	);
};
